export const API_BASE_URL = 'https://apidt.hplus.com.vn/home/api/';
//export const API_BASE_URL = 'https://duaxe.hplus.com.vn/home/api/';

export const DEFAULT_YEAR = '2025';

export const LIST_YEAR = [
	{
		value: '2025',
		title: 'Năm 2025',
		is_active: true,
	},
	{
		value: '2024',
		title: 'Năm 2024',
		is_active: false,
	},
	{
		value: '2023',
		title: 'Năm 2023',
		is_active: false,
	},
	{
		value: '2022',
		title: 'Năm 2022',
		is_active: false,
	},
	{
		value: '2021',
		title: 'Năm 2021',
		is_active: false,
	},
	{
		value: '2020',
		title: 'Năm 2020',
		is_active: false,
	},
	{
		value: '2019',
		title: 'Năm 2019',
		is_active: false,
	},
];
